<div class="flex flex-col basis-full">
  <div class="flex flex-row display">
    <mat-icon svgIcon="close" class="close-icon cursor-pointer" [matDialogClose]="false"></mat-icon>
    <div class="flex flex-col items-center mb-24">
      <mat-icon svgIcon="warning_amber" class="w-36 h-36 amber_color"></mat-icon>
      <div *ngIf="title" class="fw-700 fs-24 failed-title mt-16 mb-10">{{title}}</div>
    </div>
    <div class="message fw-500 mr-24 mb-24">
      {{message}} <span class="fw-600">"{{name}}"</span>.
    </div>
    <mat-divider class="full-width-divider w-100-percent mt-4 mb-4"></mat-divider>
    <div class="flex justify-end mt-12">
      <button class="accent report-letter-spacing" type="button" [matDialogClose]="false"> {{ 'BUTTONS.CLOSE' | transloco }} </button>
    </div>
  </div>
</div>
